import React from 'react'

// Actions
import actions from '../../actions/Platforms'

import Component from '../common/Component'
import CreateForm, { defaultPropTypes, connectCreateForm } from '../common/CreateForm'
import LabeledTextField from '../common/LabeledTextField'

export class PlatformCreate extends Component {
  static propTypes = defaultPropTypes

  render() {
    return (
      <CreateForm {...this.props}>
        <LabeledTextField
          key="name"
          name="name"
          label="Name"
        />
      </CreateForm>
    )
  }
}

export default connectCreateForm(PlatformCreate, 'Platform', 'platforms', actions)
